export const referralRules = {
    'zh-CN': {  
        referralMode: '转介绍模式',
        referralModeDescription: '开启后，企业销售成员可邀请其他用户成为下级合作伙伴。下级合作伙伴可向销售分享介绍更多客户线索，销售与介绍的客户成交后，合作伙伴则可获得相应推广赏金。',
        referralModeNote: '注：如某一用户即为企业的"<span class="cred">合作伙伴</span>"，又为企业的"<span class="cred">分销员</span>"，当他推荐的客户在<span class="cred">商城下单"分销商品"</span>后，此用户只可获得"<span class="cred">分销佣金</span>"奖励，不可重复获得"<span class="cred">推广赏金</span>"。',
        rulesPlaceholder: '为避免与用户产生纠纷，请写明详细转介绍活动规则',
        promotionRewardSetting: '推广赏金设置',
        promotionRewardDescription: '推广赏金设置：合作伙伴介绍的客户和他的上级专属伙伴发生交易（商城订单为"已完成"状态）',
        daysAfter: '天后，则可获得成交金额',
        promotionRewardPercentage: '%的推广赏金。 (第一内容填0表示不受限制)。',
        withdrawalAmountSetting: '提现金额设置：赏金满',
        withdrawalAmountDescription: '港元，则可提现 (填0表示不受限制)',
        autoWithdrawalSetting: '自动提现设置：',
        autoWithdrawalDescription: '开启后，提现的赏金无需人工审核，自动通过。',
        save: '保存',
        fillRulesError: '请先填写转介绍规则',
        saveSuccess: '保存成功',
        positiveIntegerError: '请输入正整数',
        maxDaysError: '天数最大值为999'
      },
    'zh-TW': {
        referralMode: '轉介紹模式',
        referralModeDescription: '開啟後，企業銷售成員可邀請其他用戶成為下級合作伙伴。下級合作伙伴可向銷售分享介紹更多客戶線索，銷售與介紹的客戶成交後，合作夥伴則可獲得相應推廣賞金。',
        referralModeNote: '注：如某一用戶即為企業的"<span class="cred">合作伙伴</span>"，又為企業的"<span class="cred">分銷員</span>"，當他推薦的客戶在<span class="cred">商城下單"分銷商品"</span>後，此用戶只可獲得"<span class="cred">分銷佣金</span>"獎勵，不可重複獲得"<span class="cred">推廣賞金</span>"。',
        rulesPlaceholder: '為避免與用戶產生糾紛，請寫明詳細轉介紹活動規則',
        promotionRewardSetting: '推廣賞金設置',
        promotionRewardDescription: '推廣賞金設置：合作夥伴介紹的客戶和他的上級專屬夥伴發生交易（商城訂單為"已完成"狀態）',
        daysAfter: '天後，則可獲得成交金額',
        promotionRewardPercentage: '%的推廣賞金。 (第一內容填0表示不受限制)。',
        withdrawalAmountSetting: '提現金額設置：賞金滿',
        withdrawalAmountDescription: '港元，則可提現 (填0表示不受限制)',
        autoWithdrawalSetting: '自動提現設置：',
        autoWithdrawalDescription: '開啟後，提現的賞金無需人工審核，自動通過。',
        save: '保存',
        fillRulesError: '請先填寫轉介紹規則',
        saveSuccess: '保存成功',
        positiveIntegerError: '請輸入正整數',
        maxDaysError: '天數最大值為999'
      },
      'en': {
        referralMode: 'Referral Mode',
        referralModeDescription: 'After enabling, enterprise sales members can invite other users to become subordinate partners. Subordinate partners can share and introduce more customer leads to sales. After sales complete transactions with introduced customers, partners can receive corresponding promotion rewards.',
        referralModeNote: 'Note: If a user is both a "<span class="cred">Partner</span>" and a "<span class="cred">Distributor</span>" of the enterprise, when their recommended customer places an order for "<span class="cred">Distribution Products</span>" in the mall, this user can only receive "<span class="cred">Distribution Commission</span>" rewards and cannot receive "<span class="cred">Promotion Rewards</span>" repeatedly.',
        rulesPlaceholder: 'To avoid disputes with users, please write detailed referral activity rules',
        promotionRewardSetting: 'Promotion Reward Settings',
        promotionRewardDescription: 'Promotion Reward Settings: When a customer introduced by a partner completes a transaction with their superior exclusive partner (mall order status is "Completed")',
        daysAfter: 'days later, they can receive the transaction amount',
        promotionRewardPercentage: '% promotion reward. (Fill 0 in the first field means no limit).',
        withdrawalAmountSetting: 'Withdrawal Amount Settings: When rewards reach',
        withdrawalAmountDescription: 'yuan, withdrawal is allowed (Fill 0 means no limit)',
        autoWithdrawalSetting: 'Auto Withdrawal Settings:',
        autoWithdrawalDescription: 'After enabling, withdrawal rewards will be automatically approved without manual review.',
        save: 'Save',
        fillRulesError: 'Please fill in the referral rules first',
        saveSuccess: 'Saved successfully',
        positiveIntegerError: 'Please enter a positive integer',
        maxDaysError: 'Maximum days value is 999'
      }
    }
    